import { ReactNode } from 'react';
import { ICON_CIRCLE_STYLES } from '@sib/config';
import { cn } from '@sib/ui';

interface InformationWrapperProps {
  icon: ReactNode;
  title: string;
  description?: string;
  footer?: ReactNode;
  className?: string;
  customIconClassName?: string;
  customTitleClassName?: string;
}

export const InformationWrapper = ({
  icon,
  title,
  description,
  footer,
  className,
  customIconClassName,
  customTitleClassName,
}: InformationWrapperProps) => (
  <div
    className={cn(
      'mt-10 flex flex-col items-center justify-start gap-4',
      className
    )}
  >
    <div
      className={cn(
        ICON_CIRCLE_STYLES,
        'flex items-center justify-center',
        customIconClassName
      )}
    >
      {icon}
    </div>
    <div className="flex w-full flex-col items-center justify-center gap-3 text-center">
      <p
        className={cn(
          'text-primary max-w-[90%] text-[28px] leading-[42px] font-medium tracking-normal',
          customTitleClassName
        )}
      >
        {title}
      </p>
      {description && (
        <p className="text-muted-foreground max-w-[90%] leading-[22px] font-normal tracking-normal sm:max-w-[60%]">
          {description}
        </p>
      )}
    </div>
    {footer && <div className="mt-5">{footer}</div>}
  </div>
);
